<template>
    <internal>
        <div
            class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg pb-48"
        >
            <loading :showLoading="form.processing"/>
            <div
                :class="{
                    'opacity-50': form.processing,
                    'opacity-100': !form.processing,
                }"
            >
                <p class="text-lg font-medium mb-4">Add Result & Certificate</p>
                <form @submit.prevent="handleSubmitForm">
                    <div class="grid lg:grid-cols-3 gap-4 mb-4">
                        <div class="grid w-full">
                            <label for="result" class="cursor-pointer">
                                <Label value="Result"/>
                                <InputCheckbox @input="handleEmptyAdmission" id="result" required type="radio"
                                               class="rounded-full mt-4" name="type"
                                               :value="'result'"
                                               v-model="form.type" :checked="form.type == 'result'"/>
                            </label>
                            <label for="certificate" class="cursor-pointer">
                                <Label value="Certificate"/>
                                <InputCheckbox @input="handleEmptyAdmission" id="certificate" required type="radio"
                                               value="certificate"
                                               :checked="form.type == 'certificate'"
                                               class="rounded-full mt-4" name="type" v-model="form.type"/>
                            </label>
                            <div class="col-span-2">
                                <InputError :message="form.errors?form.errors.type:''"/>
                            </div>
                        </div>

                        <div v-if="form.type=='certificate'">
                            <FormMultiselect
                                @change="(value)=>{
                                    form.course_id = value;
                                    form.semester_id = '';
                                    handleSelectCourse()
                                }"
                                :required="true"
                                label="Course"
                                :options="courses"
                                track-key="title"
                                label-key="title"
                                return-key="id"
                                v-model="form.course_id"
                                :placeholder="'Select Course'"
                                :error="form.errors.course_id"
                            />
                        </div>

                        <div v-if="form.type=='result'">
                            <FormMultiselect
                                @change="(value)=>{
                                    form.semester_id = value;
                                    handleSelectCourse()
                                }"
                                :required="true"
                                label="Semester"
                                :options="semesters"
                                track-key="title"
                                label-key="title"
                                return-key="id"
                                v-model="form.semester_id"
                                :placeholder="'Select Semester'"
                                :error="form.errors.semester_id"
                            />
                        </div>
                        <div>
                            <FormMultiselect
                                :required="true"
                                label="Students"
                                :options="admissions.map((item)=>{
                                   return {
                                        id:item.id,
                                        title:`${item.student.first_name} ${item.student?.middle_name??''} ${item.student.last_name}`
                                   }
                                })"
                                track-key="title"
                                label-key="title"
                                return-key="id"
                                mode="tags"
                                v-model="form.admission_id"
                                :placeholder="'Select Students'"
                                :error="form.errors.admission_id"
                            />
                        </div>

                    </div>

                    <div></div>
                    <ButtonLink :href="route('internal.result-and-certificates.index',branchid)"
                                class="bg-red-500 mr-4 hover:bg-red-400">Cancel
                    </ButtonLink>
                    <Button :disabled="form.processing">Submit</Button>
                    <p class="pt-2 text-red-600 text-sm" v-html=" form.error_message">

                    </p>
                </form>
            </div>
        </div>
    </internal>
</template>

<script setup>
import Internal from "@/Pages/Internal/Internal";
import Loading from "@/Components/Loading";
import {useForm, usePage} from "@inertiajs/inertia-vue3";
import Button from "@/Components/Button.vue";
import Label from "@/Components/Label.vue";
import InputCheckbox from "@/Components/InputCheckbox.vue";
import InputError from "@/Components/InputError.vue";
import ButtonLink from "@/Components/ButtonLink.vue";
import FormMultiselect from "@/Components/Forms/FormMultiselect.vue";
import {ref} from "vue";

const admissions = ref([]);
const courses = usePage().props.value.courses;
const semesters = usePage().props.value.semesters;
const branchid = localStorage.branchId;

const form = useForm({
    type: 'result',
    admission_id: [],
    course_id: '',
    semester_id: '',
    error_message: '',
});

const handleSubmitForm = () => {
    form.post(route('internal.result-and-certificates.store', branchid), {
        onSuccess: (resp) => {
            console.log(resp.props.flash.data)
            showErrorMessage(resp.props.flash.data, 100000);
        }
    })
}
const handleSelectCourse = () => {
    admissions.value = [];
    form.admission_id = [];
    form.post(route('internal.result-and-certificates.ajax', branchid), {
        onSuccess: (reso) => {
            admissions.value = reso.props.flash.data.admissions;
        }
    })
}

const showErrorMessage = (message = '', timeOut = 3000) => {
    form.error_message = message;
    setTimeout(() => {
        form.error_message = '';
    }, timeOut);
}
const handleEmptyAdmission = () => {
    admissions.value = [];
    form.course_id = '';
    form.semester_id = '';
    form.admission_id = [];
}
</script>
